module.exports = __webpack_public_path__ + "img/reimbursementManagementChose.ee0850c6.svg";